
import { Component, Vue, Watch } from "vue-property-decorator";
import Modal from "@/views/modal/Modal.vue";
import { User } from "@/models/user";
import Axios from "axios";
import { API_STORE } from "@/config";
import { getAPIAuthorizedHeader, EventBus } from "@/services/common";
import AsyncPageLoader from "@/views/AsyncPageLoader.vue";
import { USER_TYPE } from "@/constant";
import ScrollPaginationMixin from "@/mixins/Pagination.mixin";
import { mixins } from "vue-class-component";
import moment from "moment";
Vue.prototype.moment = moment;

import store from "@/store/store";
const Store: any = store;

@Component({ components: { Modal } })
export default class UserListComponent extends mixins(ScrollPaginationMixin) {
  public userTypes = USER_TYPE;
  public selectedUserType = null;
  public usersList = [];
  public searchString = null;
  public showModal = false;
  public descending = true;
  public callBySuperAdmin = false;
  public isUserListEmpty = true;
  public totalAmount = 0;
  public modalData = {
    component: null,
    data: null,
    title: null,
  };

  public debitAccess = false;

  public onSearchString() {
    this.paginationConfig.currentPage = 1;
    this.listUsers();
  }
  public onChangeUserType() {
    this.paginationConfig.currentPage = 1;
    this.listUsers();
  }

  public onPageChange(page) {
    this.paginationConfig.currentPage = page;
    this.listUsers();
  }

  public async listUsers() {
    this.asyncPageLoader = true;
    let obj = {
      searchString: this.searchString,
      limit: this.paginationConfig.pageLimit,
      page: this.paginationConfig.currentPage,
      addedBy: this.$userId,
      isClient: this.callBySuperAdmin ? true : this.$isClient,
      userType: this.selectedUserType,
      subdomain: this.callBySuperAdmin
        ? this.$route.query.subdomain
        : this.$client.subdomain,
    };
    let response = await Axios.post(API_STORE.CONFIG + "getUsers", obj, {
      headers: getAPIAuthorizedHeader(),
    });
    this.asyncPageLoader = false;
    if (response) {
      if (response.data && response.data.users && response.data.users.docs) {
        this.paginationConfig.totalPages = response.data.users.totalPages;
        this.paginationConfig.totalLength = response.data.users.totalDocs;
        this.usersList = response.data.users.docs;
        if (this.usersList.length > 0 && this.counter == 0) {
          this.counter++;
          this.isUserListEmpty = false;
        }
      }
      this.totalAmount = response.data.totalAmount;
    }
  }

  public passUserdataToState(userId) {
    let query = {
      subdomain: this.callBySuperAdmin
        ? this.$route.query.subdomain
        : this.$client.subdomain,
      clientUserId: this.callBySuperAdmin
        ? this.$route.query.clientUserId
        : this.$client.clientUserId,
    };
    if (userId) query = { ...query, ...{ userId: userId } };
    this.$router.push({
      path: "/portal/configuration/updateUser",
      query: query,
    });
  }

  public confirmDeleteAction(userId) {
    this.$dialog
      .confirm(`Are you sure you want to delete?`, {
        okText: "Yes",
        cancelText: "No",
        reverse: false,
      })
      .then(() => {
        this.deleteUser(userId);
      })
      .catch(() => {});
  }

  public confirmAction(checked, userId) {
    this.$dialog
      .confirm(
        `Do you want to ${checked ? "activate" : "disable"} this user?`,
        {
          okText: "Yes",
          cancelText: "No",
          reverse: false,
        }
      )
      .then(() => {
        this.updateUser(checked, userId);
      })
      .catch(() => {
        this.listUsers();
      });
  }

  public async updateUser(active, userId) {
    this.$showLoader(true);
    let response = await Axios.post(
      API_STORE.CONFIG + "updateUserStatus",
      {
        active: active,
        subdomain: this.callBySuperAdmin
          ? this.$route.query.subdomain
          : this.$client.subdomain,
        userId: userId,
      },
      { headers: getAPIAuthorizedHeader() }
    );
    this.$showLoader(false);
    if (response) {
      this.$snotify.success(response.data.message);
      this.listUsers();
    }
  }

  // TDS update 
  public confirmTdsAction(checked, userId) {
    this.$dialog
      .confirm(
        `Do you want to ${checked ? "activate" : "disable"} this user?`,
        {
          okText: "Yes",
          cancelText: "No",
          reverse: false,
        }
      )
      .then(() => {
        this.updateUserTds(checked, userId);
      })
      .catch(() => {
        this.listUsers();
      });
  }

  public async updateUserTds(active, userId) {
    this.$showLoader(true);
    let response = await Axios.post(
      API_STORE.CONFIG + "updateUserTDSStatus",
      {
        tdsActive: active,
        subdomain: this.callBySuperAdmin
          ? this.$route.query.subdomain
          : this.$client.subdomain,
        userId: userId,
      },
      { headers: getAPIAuthorizedHeader() }
    );
    this.$showLoader(false);
    if (response) {
      this.$snotify.success(response.data.message);
      this.listUsers();
    }
  }

  // Aeps Onboarding
  public confirmAEPSAction(checked, userId) {
    this.$dialog
      .confirm(
        `Do you want to ${checked ? "activate" : "disable"} this user onboarding?`,
        {
          okText: "Yes",
          cancelText: "No",
          reverse: false,
        }
      )
      .then(() => {
        this.updateUserAepsOnboarding(checked, userId);
      })
      .catch(() => {
        this.listUsers();
      });
  }

  public async updateUserAepsOnboarding(active, userId) {
    this.$showLoader(true);
    let response = await Axios.post(
      API_STORE.COMMON + "updateUserAepsStatus",
      {
        aepsStatus: active,
        subdomain: this.callBySuperAdmin
          ? this.$route.query.subdomain
          : this.$client.subdomain,
        userId: userId,
      },
      { headers: getAPIAuthorizedHeader() }
    );
    this.$showLoader(false);
    if (response) {
      this.$snotify.success(response.data.message);
      this.listUsers();
    }
  }

  public async deleteUser(userId) {
    this.$showLoader(true);
    let response = await Axios.delete(API_STORE.CONFIG + "deleteUser", {
      params: {
        userId: userId,
        subdomain: this.callBySuperAdmin
          ? this.$route.query.subdomain
          : this.$client.subdomain,
      },
      headers: getAPIAuthorizedHeader(),
    });
    this.$showLoader(false);
    if (response) {
    this.$snotify.success(response.data.message);
    this.counter = 0;
    this.listUsers();
    }
  }

  public refresh() {
    this.searchString = null;
    this.listUsers();
  }

  public performedTransaction(transactionType, userId, userName) {
    this.showModal = true;
    this.modalData.component = "paymentTransaction";
    this.modalData.title = "Payment Transaction";
    this.modalData.data = {
      transactionType: transactionType,
      userId: userId,
      userName: userName,
      subdomain: this.$client ? this.$client.subdomain : null,
    };
  }

  public updateParentUserId(user) {
    this.showModal = true;
    this.modalData.component = "updateParent";
    this.modalData.title = "Update Parent User";
    this.modalData.data = {
      userId: user._id,
      userType: user.userType,
      parentId: user.parentId,
      subdomain: this.callBySuperAdmin
        ? this.$route.query.subdomain
        : this.$client.subdomain,
    };
  }

  public async walletRefresh(userId) {
    this.$showLoader(true);
    let response = await Axios.get(API_STORE.ADMIN + "refreshWallet", {
      params: {
        userId: userId
      },
      headers: getAPIAuthorizedHeader(),
    });
    this.$showLoader(false);
    if (response) {
    this.$snotify.success(response.data.message);
    }
  }


  public resetModal() {
    this.showModal = false;
    this.modalData = {
      data: null,
      component: null,
      title: null,
    };
  }

  public async updatePaymentTransaction() {
    this.resetModal();
    EventBus.$emit("refreshWalletAmount", true);
    this.listUsers();
  }

  mounted() {
    if (this.$route.query.subdomain) {
      this.callBySuperAdmin = true;
    }
    this.listUsers();

    this.debitAccess = Store.state.accessRightPermission.Debit ? true : false;
  }
}
